/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
import mbpUtil from '@api-util/mbp';

// Plugin Config
const cardIslePluginConfig = {
    sdkURL: mbpUtil.getEnv('APP_CARD_ISLE_SDK_URL'),
    cardIsleOccasionURL: mbpUtil.getEnv('APP_CARD_ISLE_OCCASION_SDK_URL'),
    cardIsleGiftCardsURL: mbpUtil.getEnv('APP_CARD_ISLE_GIFTCARDS'),
    cardIslePdpURL: mbpUtil.getEnv('APP_CARD_ISLE_PDP_SDK_URL'),
};

export {
    cardIslePluginConfig,
};

export default {};
